export default {
  colors: {
    primary: 'hsl(11, 73%, 66%)',
    dark: 'hsl(270, 3%, 11%)',
    white: 'hsl(0, 0%, 100%)',
    secondary: 'hsl(11, 100%, 80%)',
    darkGrey: 'hsl(264, 5%, 20%)',
    lightGrey: 'hsl(210, 17%, 95%)',
    lightPink: 'hsl(14, 76%, 97%)',
  },
  breakpoints: [768, 1050, 1440],
}
